export default {
  strict: true,
  namespaced: true,
  state: {
    create: {
      pickup: {},
      dropoff: {},
      pickupDate: '',
      pickupDateReturn: '',
      isReturnTrip: false,
      adult: 1,
      children: 0,
      infants: 0
    }
  },
  mutations: {
    setCreateData (state, data) {
      for (let field in data) {
        state.create[field] = data[field]
      }
    },
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/flights/create.js